export default (array) =>
  array.filter((value) => {
    if (value instanceof Array) return value.filter((v) => v).length;
    return value;
  });
